<div class="dialog-container">
  <mat-icon class="close-button" (click)="onClose()">close</mat-icon>
  <img class="main-icon" src="assets/images/alert-icon.svg" alt="alert icon" />
  <h5 class="heading" [innerHTML]="data.title"></h5>
  <div class="sucessBtn">
    <button
      *ngIf="data.cancelButton.show"
      mat-raised-button
      (click)="onCancel()"
      class="back-btn btn"
    >
      {{ data.cancelButton.text }}
    </button>
    <button
      *ngIf="data.acceptButton.show"
      mat-raised-button
      (click)="onAccept()"
      color="primary"
      class="accept-btn btn"
    >
      {{ data.acceptButton.text }}
    </button>
  </div>
</div>
